const ExecutionTypes = [{ name: "INTERNAL" }, { name: "EXTERNAL" }];
export default ExecutionTypes;
